import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import AssetsLoader from './_load/AssetsLoader'
import ChildrenServiceOrderLoader from './_load/ChildrenServiceOrderLoader'
import { DOCUMENTS } from './documents'
import PageContent from './PageContent'
import PageHeader from './_shared/PageHeader'
import ServiceOrderLoader from './_load/ServiceOrderLoader'

const TemplateBiofixPdfPage = ({ id, templateId, variant = DOCUMENTS.communication }) => (
  <AbsolutePageTemplate>
    <ServiceOrderLoader id={parseInt(id)}>
      <ChildrenServiceOrderLoader parentId={parseInt(id)}>
        <AssetsLoader>
          <PageHeader templateId={parseInt(templateId)} variant={variant} />
          <PageContent variant={variant} />
        </AssetsLoader>
      </ChildrenServiceOrderLoader>
    </ServiceOrderLoader>
  </AbsolutePageTemplate>
)

export default TemplateBiofixPdfPage
